import { current } from "@reduxjs/toolkit";

interface HandleListCommonProps {
  loaderKey: string;
  listKey: string;
}

interface HandleAssetLoaderCommonProps {
  loaderKey: string;
}

type Status = "pending" | "fulfilled" | "rejected";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const getAssetTarget = (state: any, action?: any, assetId?: string) => {
  let currentAssetId = assetId;
  if (!currentAssetId) {
    currentAssetId = action.meta.arg?.assetId;
  }
  const stateData = current(state.application);
  const isMainAsset = stateData.asset._id === currentAssetId;
  return isMainAsset
    ? state.application.asset
    : state.application.additionalAssets.find((el: any) => el?._id === currentAssetId);
};

export const handleGlassesFieldsListState = (
  state: any,
  action: any,
  { loaderKey, listKey }: HandleListCommonProps,
  status: Status,
) => {
  const target = getAssetTarget(state, action);

  if (!target) return;

  switch (status) {
    case "pending":
      target[loaderKey] = true;
      target[listKey] = [];
      break;

    case "rejected":
      target[loaderKey] = false;
      target[listKey] = [];
      break;

    case "fulfilled":
      const data = action.payload?.data?.data;

      if (!data || JSON.stringify(data) === "{}") {
        target[loaderKey] = false;
        target[listKey] = [];
        return;
      }
      target[loaderKey] = false;
      target[listKey] = Array.isArray(data) ? data : [data];
      break;

    default:
      break;
  }

  return;
};

interface AssetFieldsListHandlerConfig {
  loaderKey: string;
  dataKey?: string;
  transformPayload?: (payload: any) => any;
}

export const handleAssetFieldsListState = (state: any, action: any, config: AssetFieldsListHandlerConfig) => {
  let assetId = undefined;
  if (action.meta.arg?.assetId) {
    assetId = action.meta.arg?.assetId;
  } else {
    assetId = action.meta.arg?.includes("assetId") ? action.meta.arg.split("assetId=")[1] : undefined;
  }
  const target = getAssetTarget(state, null, assetId);

  if (!target) return;

  const { loaderKey, dataKey, transformPayload } = config;

  const typeParts = action.type.split("/");
  const status = typeParts[typeParts.length - 1];

  switch (status) {
    case "pending":
      target[loaderKey] = true;
      if (dataKey) target[dataKey] = null;
      break;

    case "rejected":
      target[loaderKey] = false;
      if (dataKey) target[dataKey] = null;
      break;

    case "fulfilled":
      target[loaderKey] = false;
      if (dataKey) {
        target[dataKey] = transformPayload ? transformPayload(action.payload) : action.payload?.data?.data;
      }
      break;

    default:
      break;
  }
  return;
};

export const handleAssetLoaderState = (state: any, action: any, { loaderKey }: HandleAssetLoaderCommonProps) => {
  const typeParts = action.type.split("/");
  const status = typeParts[typeParts.length - 1];

  switch (status) {
    case "pending":
      state[loaderKey] = {
        assetId: action.meta.arg?.assetId,
        isLoading: true,
      };
      break;

    case "rejected":
      state[loaderKey] = {
        assetId: "",
        isLoading: false,
      };
      break;

    case "fulfilled":
      state[loaderKey] = {
        assetId: "",
        isLoading: false,
      };
      break;

    default:
      break;
  }
  return;
};
